import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import ProjectsLoader from './_load/ProjectsLoader'
import ControlledModal from '../../../components/modals/ControlledModal'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TemplatesList from './TemplatesList'

const ProjectTemplatesModal = props => {
  return (
    <ControlledModal width="64rem" fullScreen {...props}>
      <FilterHandler tempStorageNamespace="projects">
        <ProjectsLoader>
          <ModalHeader />

          <LineSeparator weight={2} />
          <Separator weight={6} />

          <TemplatesList />
        </ProjectsLoader>
      </FilterHandler>
    </ControlledModal>
  )
}

export default ProjectTemplatesModal
